var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "System Icon /Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Explorer-Desktop@1440px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-Order-Detail_Open",
    transform: "translate(-436.000000, -296.000000)",
    fill: "#073C50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ID",
    transform: "translate(24.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-Icon-/Copy",
    transform: "translate(412.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 L12,8.5 L8.5,8.5 L8.5,12 L0,12 L0,3.5 L3.5,3.5 L3.5,0 L12,0 Z M7,5 L1.5,5 L1.5,10.5 L7,10.5 L7,5 Z M10.5,1.5 L5,1.5 L5,3.5 L8.5,3.5 L8.5,7 L10.5,7 L10.5,1.5 Z",
    id: "Copy"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconDark);
export default __webpack_public_path__ + "static/media/CopyIconDark.e8f60eb09b3438d6768e8b178a89edc2.svg";
export { ForwardRef as ReactComponent };